var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "6D9EE645-30D6-4183-85B1-B2167DC1DE5A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Components",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Footer---Mobile---Open",
    transform: "translate(-236.000000, -108.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Footer-/-Option-D-/-Mobile-(XS)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Footer-/-\\u03DF-/-Head-/-Option-D-/-Latitude-/-Mobile-(XS)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Footer-/-\\u03DF-/-Head-/-Latitude-/-Mobile-(XS)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Social",
    transform: "translate(15.000000, 108.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "RH-Column",
    transform: "translate(175.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Social-/-Twitter",
    transform: "translate(46.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5432699,10.8574377 C25.8540469,17.7829869 20.6899602,25.504644 11.5476928,25.504644 C8.76721215,25.504644 6.17897685,24.6890756 4,23.2920537 C6.61182368,23.5998821 9.21951939,22.8757187 11.2894,21.252838 C9.13519092,21.2133274 7.31652661,19.7897685 6.69025505,17.8337019 C7.46159516,17.9811293 8.22055138,17.9380805 8.91346012,17.7499631 C6.5451865,17.2734778 4.91110128,15.1404983 4.96417514,12.8595017 C5.62818812,13.2280702 6.38773404,13.449801 7.19504644,13.4745688 C5.00191656,12.0097302 4.38095238,9.11425623 5.67123692,6.90107622 C8.09907121,9.88028896 11.7269645,11.8404836 15.8195489,12.0462922 C15.1018723,8.96564942 17.4383016,6 20.6162465,6 C22.0327289,6 23.3123986,6.59737579 24.2099366,7.55447442 C25.3315642,7.33392304 26.3853752,6.92407489 27.3365767,6.35972284 C26.9691877,7.50965649 26.1884122,8.47501106 25.1717529,9.08359133 C26.1677724,8.96505971 27.1166151,8.70028011 28,8.30871296 C27.340115,9.29647649 26.5050862,10.1633496 25.5432699,10.8574377",
    id: "Path"
  })))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.afe09dd8.svg";
export { ForwardRef as ReactComponent };